import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Marks all of the current user's notifications as read.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @returns OperationResult (no payload).
 */
export const readAllNotifications = async (instance: KyInstance): Promise<OperationResult> => {
  try {
    return await instance.post<OperationResult>(Uri.notifications.readAll).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
